import '../styles/chunks/app.seo.styl';
import { dispatch, getState } from 'services/store';
import { requestInlines, requestSuggestionBox } from 'actions/adActions';
import { COOKIES } from 'constants/constants';
import CookiesBanner from 'atoms/cookie-banner';
import { store as globalStore } from 'app/boot/init';
import { hasKanji } from 'services/slug';
import HeaderContainer from 'app/components/header-container';
import HeaderSeo from 'app/templates/landing-seo/header';
import { ID_ROUTES } from 'constants/routes';
import ModalContainer from 'components/modal/new-modal/modal-container';
import NotificationsBannerController from 'components/search/NotificationsBannerController';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import React from 'react';
import { render } from 'react-dom';
import SearchBarContainer from 'molecules/search-bar/container';
import { selectDestination } from 'actions/searchFormActions';
import SeoEstablishmentContainer from 'app/templates/establishment/seo-container';
import SeoSnippetAdContainer from 'components/ads/seo-inline';
import { setContext } from 'services/context';
import SubMenu from 'templates/landing-seo/sub-menu';
import SuggestionBox from 'molecules/suggestion-box/container';
import { t } from 'services/Intl';
import { trackPageView } from 'services/tracking';


function SeoLandingApp({ store, destination }) {
  trackPageView();
  return (
    <Provider store={ store }>
      <span>
        <SearchBarContainer
          className="landing-page__search-bar"
          destination={ destination }
          isLandingSeo={ true }
          route={ ID_ROUTES.SEO }
        />
        <SuggestionBox
          adLogo="https://static.100r.systems/img/inline-ads/airbnb_logo.png"
          className="landing-page__suggestion-box"
          underComponent="seo-establishment-inline"
        />
        <ModalContainer />
        <NotificationsBannerController />
        <SeoSnippetAdContainer />
      </span>
    </Provider>
  );
}

SeoLandingApp.defaultProps = {
  destination: '',
};

SeoLandingApp.propTypes = {
  destination: PropTypes.string,
  store: PropTypes.shape().isRequired,
};

function SeoEstablishmentApp({ store }) {
  trackPageView();
  return (
    <Provider store={ store }>
      <span>
        <HeaderContainer
          className="search seo"
          hasSearchBar={ true }
        />
        <SeoEstablishmentContainer
          allPartners={ global.SERVERDATA.props.allPartners }
          breadcrumb={ global.SERVERDATA.props.breadcrumb }
          establishment={ global.SERVERDATA.props.establishment }
          id={ global.SERVERDATA.props.id }
          location={ window.location }
        />
        <ModalContainer />
        <NotificationsBannerController />
      </span>
    </Provider>
  );
}

SeoEstablishmentApp.propTypes = {
  store: PropTypes.shape().isRequired,
};

const pageType = global.SERVERDATA.props ? global.SERVERDATA.props.type : null;

if (pageType && pageType === 'establishment') {
  const AppIntl = setContext(SeoEstablishmentApp, global.hr.intl, global.isPhone, global.isTablet);
  render(<AppIntl store={ globalStore } />, document.querySelector('#seo-establishment'));
}

if (pageType && pageType !== 'establishment') {
  const AppIntl = setContext(SeoLandingApp, global.hr.intl, global.isPhone, global.isTablet);
  const HeaderSeoIntl = setContext(HeaderSeo, global.hr.intl, global.isPhone, global.isTablet);
  render(<AppIntl store={ globalStore } />, document.querySelector('#search-bar'));
  render(<HeaderSeoIntl
    domain={ global.hr.intl.DOMAIN }
    handleOnClickLinks={ () => {} }
    handleOnClickLogo={ () => global.browserHistory.push('/') }
    links={ global.SERVERDATA.props.menu || [] }
  />, document.querySelector('#header-seo'));

  if (global.SERVERDATA.props && global.SERVERDATA.props.submenu && global.SERVERDATA.props.submenu.length) {
    render(<SubMenu
      handleChange={ () => {} }
      items={ global.SERVERDATA.props.submenu }
      selected={ global.SERVERDATA.props.selected }
    />, document.querySelector('#submenu-seo'));
  } else {
    document.querySelector('#submenu-seo').style.display = 'none';
  }
}

// Request geo data for a romaji name if we need it
const destination = global.SERVERDATA && global.SERVERDATA.state && global.SERVERDATA.state.destination;
if (destination && hasKanji(destination.name)) dispatch(selectDestination(destination.name, destination.country, destination.place_id));

// Dispatch request inlines
const currentState = getState();
const search = Object.assign({}, currentState.destination, currentState.searchFormReducer);
dispatch(requestInlines(search));
dispatch(requestSuggestionBox(search));

// Render cookies banner
const cookiesBanner = document.querySelector('#cookies-banner');
const literal = t('This site uses first and third party cookies to help you provide you with the best experience that we can. By continuing to browse Hundredrooms, you are agreeing to our use of cookies.');
if (cookiesBanner) {
  render(<CookiesBanner
    cookieName={ COOKIES.COOKIES_BANNER }
    dispatch={ dispatch }
    literal={ literal }
  />, cookiesBanner);
}

// Render inline ad
const inlineContainer = document.querySelector('#ad-inline');
const inline = document.querySelector('.snippet-ad.-seo-ad');
const establishments = document.querySelectorAll('.landing-page__establishments__list').length;

if (inlineContainer && inline && establishments) {
  inlineContainer.classList.add('landing-page__establishments__list');
  inlineContainer.appendChild(inline);
}

if (establishments === 0 && pageType && pageType !== 'establishment') ((document.querySelector('#first_h2') || {}).style || {}).display = 'none';

global.history.pushState = (state, title, url) => {
  global.location.href = url;
};
